import React, { useEffect, useState } from "react";
import ChatListItem from "./ChatListItem";
import { Alert, InputAdornment, TextField } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { useDispatch } from "react-redux";
import {
  fetchChatDetail,
  fetchChatList,
  fetchChatSend,
  fetchChatReloadDetail,
  fetchChatClearDetailList,
} from "../actions/chat";
import { useSelector } from "react-redux";
import ChatCenterForm from "../components/Admin/Reusable/ChatCenterForm";
import { chatActions } from "../reducers/chat";
import { useTranslation } from "react-i18next";

const Chat = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeChat, setActiveChat] = useState(null);
  const [activeUser, setActiveUser] = useState({});
  const { chatList, chatDetail } = useSelector((state) => state.chatReducer);

  const [search, setSearch] = useState("");
  const [message, setMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  const handleItemClick = (index, user) => {
    if (user.unreadCount > 0) {
      // Prvo, postavljamo unreadCount na 0 za odabranog korisnika
      const updatedChatList = [...chatList];
      updatedChatList[index] = {
        ...updatedChatList[index],
        unreadCount: 0, // Resetovanje broja nepročitanih poruka
      };
      dispatch(chatActions.fetchChatList(updatedChatList));
    }

    setActiveIndex(index);
    setActiveUser(user);
    setActiveChat(user.id);
    dispatch(fetchChatDetail(user.id, 0, 1000));
  };

  useEffect(() => {
    dispatch(fetchChatList());
    dispatch(fetchChatClearDetailList());
  }, [dispatch]);

  const filteredUsers =
    search != ""
      ? chatList?.filter((user) =>
          user.name.toLowerCase().includes(search.toLowerCase())
        )
      : chatList;

  const handleRemoveFile = () => {
    setSelectedImage(null); // Ukloni fajl
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
    }
  };

  const handleSendMessage = () => {
    setMessage("");
    setSelectedImage(null);

    const formData = new FormData();
    if (selectedImage) {
      formData.append("fileType", "IMAGE");
      formData.append("file", selectedImage);
    }
    formData.append("message", message);
    formData.append("chatId", activeChat);

    dispatch(fetchChatSend(formData, activeChat));
  };

  const fetchDataChat = (id) => {
    dispatch(fetchChatReloadDetail(activeUser.id, 0, 1000, id));
  };

  return (
    <div className="chat-container">
      <div className="chat-main-holder">
        <div className="chat-left-content">
          <div className="chat-left-content-title">{t("chat.title")}</div>
          <div className="chat-left-content-search">
            <TextField
              label={t("chat.search")}
              size={"small"}
              type="text"
              name="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlinedIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="chat-left-content-list">
            <h4>{t("chat.directMessages")}</h4>
            {filteredUsers?.length > 0 ? (
              filteredUsers.map((user, index) => (
                <ChatListItem
                  key={index}
                  data={user}
                  isActive={activeIndex === index}
                  onClick={() => handleItemClick(index, user)}
                />
              ))
            ) : (
              <Alert severity="info">{t("chat.info2")}</Alert>
            )}
          </div>
        </div>
        {activeUser &&
          (chatDetail?.content ? (
            <ChatCenterForm
              activeUser={activeUser}
              fetchDataChat={fetchDataChat}
              chatDetail={chatDetail}
              selectedImage={selectedImage}
              handleRemoveFile={handleRemoveFile}
              handleFileChange={handleFileChange}
              handleSendMessage={handleSendMessage}
              message={message}
              setMessage={setMessage}
            />
          ) : (
            <Alert className="chat-center-alert" severity="info">
              {t("chat.info1")}
            </Alert>
          ))}
      </div>
    </div>
  );
};

export default Chat;
